import { Link } from "@tanstack/react-router";
import { twJoin } from "tailwind-merge";

import type { ItemListItem } from "~/api-refs";

export const ItemCard = ({
  menuId,
  item,
}: {
  menuId: string;
  item: ItemListItem;
}) => {
  return (
    <Link
      className="group border-muted-foreground/5 bg-background hover:border-border focus-visible:border-foreground focus-visible:ring-md focus-visible:ring-ring/50 relative h-40 w-52 cursor-pointer rounded-md border shadow-xs transition-[color,box-shadow] focus-visible:outline-hidden"
      params={{ menuId, itemId: item.id }}
      to="/menus/$menuId/items/$itemId"
    >
      <div className="h-16 px-4 py-3">
        <p className="title text-foreground mb-1 truncate overflow-x-hidden">
          {item.name}
        </p>
        <div className="inline-flex w-full items-center justify-between">
          <p className="caption-strong text-foreground">${item.price}</p>
          <span
            className={twJoin(
              "inline-flex items-center gap-1 rounded-full px-1.5 py-0.5",
              item.isOutOfStock ? "bg-destructive/10" : "bg-success/10"
            )}
          >
            <div
              className={twJoin(
                "h-1.5 w-1.5 rounded-full",
                item.isOutOfStock ? "bg-destructive" : "bg-success"
              )}
            />
            <p
              className={twJoin(
                "caption",
                item.isOutOfStock ? "text-destructive" : "text-success"
              )}
            >
              {item.isOutOfStock ? "Out of stock" : "Available"}
            </p>
          </span>
        </div>
      </div>
      <div>
        <img
          alt={`${item.name} image`}
          className="group-hover:border-b-border group-focus-visible:border-b-border max-h-[90px] rounded-b-md border-b border-b-transparent object-cover"
          height={90}
          src={item?.imageUrl ?? "/images/menu-item-placeholder.svg"}
          width={210}
        />
      </div>
      {item.isShared && (
        <div className="caption bg-info/10 text-info absolute right-4 bottom-3 rounded-full px-2 py-1">
          Shared
        </div>
      )}
    </Link>
  );
};
